import React from 'react';

export default function GroupIcon(props) {
  return (
    <svg width='24' height='24' viewBox='0 0 32 32' {...props}>
      <g fill='currentColor'>
        <path
          d='M25 23a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM7 23a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm14 1a1 1 0 0 1 .117 1.993L21 26H11a1 1 0 0 1-.117-1.993L11 24h10zM7 10a1 1 0 0 1 .993.883L8 11v10a1 1 0 0 1-1.993.117L6 21V11a1 1 0 0 1 1-1zm6 6a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm12-6a1 1 0 0 1 .993.883L26 11v10a1 1 0 0 1-1.993.117L24 21V11a1 1 0 0 1 1-1zm-6 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm6-5a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM7 5a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm14 1a1 1 0 0 1 .117 1.993L21 8H11a1 1 0 0 1-.117-1.993L11 6h10z'
          fill='currentColor'
          fillRule='nonzero'
        />
      </g>
    </svg>
  );
}
